import React from "react";
import { CONSTANTS } from "../../constants/Constants";
import arrowDownIcon from "../../assets/icons/down_arrow_bar.svg";

interface SelectProps {
  name: string;
  options: any[];
  other_classes?: string;
  handle_change: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value?: string;
  firstOptionText?: string;
}

const Select: React.FC<SelectProps> = ({
  options,
  other_classes,
  handle_change,
  name,
  value,
  firstOptionText = CONSTANTS.SELECT_TXT,
}) => {
  return (
    <div
      className={`w-full h-12 overflow-hidden cursor-pointer flex items-center relative border border-[#E6E6E6] rounded-full pr-3  ${other_classes}`}
    >
      <select
        className={`appearance-none w-full cursor-pointer text-[#1A1A1A] overflow-hidden text-ellipsis border-none focus:outline-none px-3 !bg-transparent`}
        onChange={(e) => handle_change(e)}
        name={name}
        defaultValue={value}
      >
        <option value="">{firstOptionText}</option>
        {options.map((option: any) => {
          return (
            <option
              key={option.id}
              value={option.id}
            >
              {option.name}
            </option>
          );
        })}
      </select>
      <div className="absolute right-[10px]">
        <img src={arrowDownIcon} alt="icon" />
      </div>
    </div>
  );
};

export default Select;
